import { render, staticRenderFns } from "./PdRenewalView.vue?vue&type=template&id=166d3dbe&scoped=true&"
import script from "./PdRenewalView.vue?vue&type=script&lang=js&"
export * from "./PdRenewalView.vue?vue&type=script&lang=js&"
import style0 from "./PdRenewalView.vue?vue&type=style&index=0&id=166d3dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166d3dbe",
  null
  
)

export default component.exports